import React from 'react';
import { Typography, Spin, Card, Button } from 'antd';
import { ArrowLeftOutlined, FileTextOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { useGetTermsOfServiceQuery } from '../services/nestjs-base-api';

const { Title, Text } = Typography;

const TermsOfServicePage: React.FC = () => {
    const navigate = useNavigate();
    const { data, isLoading, error } = useGetTermsOfServiceQuery();

    const containerStyle: React.CSSProperties = {
        minHeight: '100vh',
        background: '#ffffff',
        padding: '40px 20px',
    };

    const cardStyle: React.CSSProperties = {
        maxWidth: 900,
        margin: '0 auto',
        borderRadius: 16,
        boxShadow: '0 4px 24px rgba(0, 0, 0, 0.08)',
    };

    const headerStyle: React.CSSProperties = {
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        marginBottom: 24,
        paddingBottom: 24,
        borderBottom: '1px solid #f0f0f0',
    };

    const contentStyle: React.CSSProperties = {
        maxHeight: 'calc(100vh - 280px)',
        overflow: 'auto',
        padding: '0 8px',
    };

    return (
        <div style={containerStyle}>
            <Card style={cardStyle}>
                <div style={headerStyle}>
                    <Button
                        type="text"
                        icon={<ArrowLeftOutlined />}
                        onClick={() => navigate(-1)}
                    >
                        Back
                    </Button>
                    <div style={{ flex: 1, textAlign: 'center' }}>
                        <FileTextOutlined style={{ fontSize: 32, color: '#F59E0B', marginBottom: 8 }} />
                        <Title level={2} style={{ margin: 0 }}>
                            Terms of Service
                        </Title>
                        {data?.version && (
                            <Text type="secondary">
                                Version {data.version} - Effective {data.effectiveDate ? new Date(data.effectiveDate).toLocaleDateString() : ''}
                            </Text>
                        )}
                    </div>
                    <div style={{ width: 80 }} /> {/* Spacer for centering */}
                </div>

                {isLoading && (
                    <div style={{ textAlign: 'center', padding: 60 }}>
                        <Spin size="large" />
                    </div>
                )}

                {error && (
                    <div style={{ textAlign: 'center', padding: 60 }}>
                        <Text type="danger">Unable to load terms of service. Please try again later.</Text>
                    </div>
                )}

                {data?.available && data.content && (
                    <div style={contentStyle}>
                        <ReactMarkdown>{data.content}</ReactMarkdown>
                    </div>
                )}

                {data && !data.available && (
                    <div style={{ textAlign: 'center', padding: 60 }}>
                        <Text type="secondary">Terms of service are not yet available.</Text>
                    </div>
                )}
            </Card>

            <div style={{ textAlign: 'center', marginTop: 24 }}>
                <Text type="secondary">
                    BrandScience.ai © {new Date().getFullYear()} by <a href="https://syriant.com" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}>Syriant</a>
                </Text>
            </div>
        </div>
    );
};

export default TermsOfServicePage;
